import isEqual from 'react-fast-compare';

import {
  CUSTOM_PARTY,
  CustomParty,
  MinimalEntity,
  NULL_PARTY,
} from 'ui-library/entity-input/EntityInputConstants';

export function isNullParty(obj: MinimalEntity | CustomParty): boolean {
  return isEqual(obj, NULL_PARTY);
}

export function isCustomParty(obj: object): obj is CustomParty {
  return (
    obj &&
    obj.hasOwnProperty('type') &&
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (obj as any).type === CUSTOM_PARTY &&
    obj.hasOwnProperty('text') &&
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Boolean((obj as any).text) &&
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    typeof (obj as any).text === 'string'
  );
}

export function buildCustomParties(textValues?: Array<string>): Array<CustomParty> {
  return textValues?.map((text: string) => ({type: CUSTOM_PARTY, text})) ?? [];
}
